import { useState } from 'react';

import Image from 'next/image';
import Link from 'next/link';

import { CardImages } from 'matrix';
import { Loading } from 'components/Loading';
import { DEFAULT_IMAGE, DEFAULT_IMAGE_BASE64 } from 'constants/index';
import * as El from './CityCard.css';

interface CityCardProps {
  images: CardImages;
  label: string;
  href: string;
  uuid: string;
  sectionPosition?: string;
  dataCreative?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

function CityCard({
  images,
  label = '',
  href = '#',
  uuid,
  sectionPosition = '',
  dataCreative = '',
  onClick
}: CityCardProps) {
  const [hasClicked, setHasClicked] = useState(false);

  return (
    <Link
      className={`${El.cardLink} sympla-city-card embla__slide`}
      href={href}
      prefetch={false}
      title={label}
      onClick={(event) => {
        onClick?.(event);
        if (!event.defaultPrevented) {
          setHasClicked(true);
        }
      }}
      target="_top"
      aria-label={label}
      data-bannerid={`${uuid}`}
      data-name={`${label}`}
      data-position={`${sectionPosition}`}
      data-creative={dataCreative}
    >
      <div className={`${El.cityCardContainer} embla__parallax`}>
        {hasClicked && (
          <div className={`${El.cityCardLoading} animated fadeIn`}>
            <Loading />
          </div>
        )}

        <div className={El.cityCardImageOverlay} />
        <div className={`embla__parallax__layer ${El.emblaParallaxLayer}`}>
          <div className={El.emblaParallaxImgWrapper}>
            <Image
              src={images.xs || images.lg || images.banner || DEFAULT_IMAGE}
              alt={`Imagem da cidade ${label}`}
              className={El.emblaParallaxImg}
              fill
              sizes="(max-width: 500px) 85vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw"
              loading="lazy"
              priority={false}
              placeholder="blur"
              blurDataURL={DEFAULT_IMAGE_BASE64}
              quality={65}
              decoding="async"
            />
          </div>
        </div>
        <div className={`${El.cityName} animated fadeIn`}>{label}</div>
      </div>
    </Link>
  );
}

export default CityCard;
